// Incident / accident register — the statutory record spine. Care staff record
// an incident (or it is raised from an observation); a manager triages it,
// classifies it (accident / incident / near-miss), records statutory
// notifications, optionally escalates to a safeguarding review, then closes it
// against the duty-of-candour / RIDDOR gate.

// LOCATION REGISTER — the paginated home-wide list with tab counts + filters
export const FETCH_LOCATION_INCIDENT_RECORDS =
  "app/INCIDENT_RECORD/FETCH_LOCATION_INCIDENT_RECORDS";
export const FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS =
  "app/INCIDENT_RECORD/FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS";
export const FETCH_LOCATION_INCIDENT_RECORDS_FAILURE =
  "app/INCIDENT_RECORD/FETCH_LOCATION_INCIDENT_RECORDS_FAILURE";

// RESIDENT RECORDS — this resident's records for the workspace panel
export const FETCH_RESIDENT_INCIDENT_RECORDS =
  "app/INCIDENT_RECORD/FETCH_RESIDENT_INCIDENT_RECORDS";
export const FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS =
  "app/INCIDENT_RECORD/FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS";
export const FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE =
  "app/INCIDENT_RECORD/FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE";

// GET — hydrate the drawer (record + notifications + source + linked review)
export const FETCH_INCIDENT_RECORD =
  "app/INCIDENT_RECORD/FETCH_INCIDENT_RECORD";
export const FETCH_INCIDENT_RECORD_SUCCESS =
  "app/INCIDENT_RECORD/FETCH_INCIDENT_RECORD_SUCCESS";
export const FETCH_INCIDENT_RECORD_FAILURE =
  "app/INCIDENT_RECORD/FETCH_INCIDENT_RECORD_FAILURE";

// CREATE — manual (paper) entry
export const CREATE_INCIDENT_RECORD =
  "app/INCIDENT_RECORD/CREATE_INCIDENT_RECORD";
export const CREATE_INCIDENT_RECORD_SUCCESS =
  "app/INCIDENT_RECORD/CREATE_INCIDENT_RECORD_SUCCESS";
export const CREATE_INCIDENT_RECORD_FAILURE =
  "app/INCIDENT_RECORD/CREATE_INCIDENT_RECORD_FAILURE";

// PATCH — idempotent per-step save (triage / classification / candour fields)
export const UPDATE_INCIDENT_RECORD =
  "app/INCIDENT_RECORD/UPDATE_INCIDENT_RECORD";
export const UPDATE_INCIDENT_RECORD_SUCCESS =
  "app/INCIDENT_RECORD/UPDATE_INCIDENT_RECORD_SUCCESS";
export const UPDATE_INCIDENT_RECORD_FAILURE =
  "app/INCIDENT_RECORD/UPDATE_INCIDENT_RECORD_FAILURE";

// NOTIFICATION — add a statutory notification row (CQC / LA / HSE / police / ...)
export const ADD_INCIDENT_NOTIFICATION =
  "app/INCIDENT_RECORD/ADD_INCIDENT_NOTIFICATION";
export const ADD_INCIDENT_NOTIFICATION_SUCCESS =
  "app/INCIDENT_RECORD/ADD_INCIDENT_NOTIFICATION_SUCCESS";
export const ADD_INCIDENT_NOTIFICATION_FAILURE =
  "app/INCIDENT_RECORD/ADD_INCIDENT_NOTIFICATION_FAILURE";

// ESCALATE — open (or link) a safeguarding review from this record
export const ESCALATE_INCIDENT_SAFEGUARDING =
  "app/INCIDENT_RECORD/ESCALATE_INCIDENT_SAFEGUARDING";
export const ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS =
  "app/INCIDENT_RECORD/ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS";
export const ESCALATE_INCIDENT_SAFEGUARDING_FAILURE =
  "app/INCIDENT_RECORD/ESCALATE_INCIDENT_SAFEGUARDING_FAILURE";

// CLOSE — outcome + review-due; enforces the notification / candour gate
// (HTTP 422 → { requires_override, missing_bodies } + message)
export const CLOSE_INCIDENT_RECORD =
  "app/INCIDENT_RECORD/CLOSE_INCIDENT_RECORD";
export const CLOSE_INCIDENT_RECORD_SUCCESS =
  "app/INCIDENT_RECORD/CLOSE_INCIDENT_RECORD_SUCCESS";
export const CLOSE_INCIDENT_RECORD_FAILURE =
  "app/INCIDENT_RECORD/CLOSE_INCIDENT_RECORD_FAILURE";

// REOPEN — a closed record back into review
export const REOPEN_INCIDENT_RECORD =
  "app/INCIDENT_RECORD/REOPEN_INCIDENT_RECORD";
export const REOPEN_INCIDENT_RECORD_SUCCESS =
  "app/INCIDENT_RECORD/REOPEN_INCIDENT_RECORD_SUCCESS";
export const REOPEN_INCIDENT_RECORD_FAILURE =
  "app/INCIDENT_RECORD/REOPEN_INCIDENT_RECORD_FAILURE";
